import { render, staticRenderFns } from "./widget_last_ipos.vue?vue&type=template&id=7b6b643c&scoped=true&"
import script from "./widget_last_ipos.vue?vue&type=script&lang=js&"
export * from "./widget_last_ipos.vue?vue&type=script&lang=js&"
import style0 from "./widget_last_ipos.vue?vue&type=style&index=0&id=7b6b643c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6b643c",
  null
  
)

export default component.exports